module.exports = __webpack_public_path__ + "static/dove-zoom-4035b8ae6e2206ad0b3fcee7a7a51b5a.jpg";